// src/App.jsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { createTheme, ThemeProvider, CssBaseline } from '@mui/material';
import Header from './components/Header';
import NewsList from './components/NewsList';
import NewsDetail from './components/NewsDetail';
import PageTracker from './components/PageTracker';
import Ranking from "./components/Ranking";
import Signup from "./components/Signup";
import Login from './pages/Login';
import FavoriteList from './components/FavoriteList';
import OssEntryLink from './components/OssEntryLink';
import OssList from './pages/OssList';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#ea580c' },
    background: {
      default: '#edeae4',
      paper: '#e4e0da',
    },
    text: {
      primary: '#1c1916',
      secondary: '#78716c',
    },
    divider: '#ccc8c2',
  },
  shape: { borderRadius: 2 },
  typography: {
    fontFamily: '"Courier New", Courier, monospace',
    fontSize: 13,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#edeae4',
          scrollbarColor: '#ccc8c2 #edeae4',
          '&::-webkit-scrollbar': { width: 6 },
          '&::-webkit-scrollbar-track': { background: '#edeae4' },
          '&::-webkit-scrollbar-thumb': { background: '#ccc8c2', borderRadius: 3 },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: { textTransform: 'none', fontFamily: '"Courier New", Courier, monospace' },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { fontFamily: '"Courier New", Courier, monospace', borderRadius: 2 },
      },
    },
  },
});

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <PageTracker />
        <Header />
        <OssEntryLink />
        <Routes>
          <Route path="/" element={<NewsList />} />
          <Route path="/article/:id" element={<NewsDetail />} />
          <Route path="/ranking" element={<Ranking />} />
          <Route path="/Signup" element={<Signup />} />
          <Route path="/login" element={<Login />} />
          <Route path="/favorites" element={<FavoriteList />} />
          <Route path="/oss" element={<OssList />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
};

export default App;
